import type { ComponentType } from "react";

import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import type { UnknownProps } from "app/pages/sales-intelligence/types";

type HocProps = {
    withAiAgentFilterMode: boolean;
};

export const withAiAgentGuard = <Props extends UnknownProps = UnknownProps>(
    Component: ComponentType<Props & HocProps>,
) => {
    return function WrappedWithAiAgentGuard(props: Props) {
        return (
            <Component
                {...props}
                withAiAgentFilterMode={salesSettingsHelper.isLeadGenAgentEnabled}
            />
        );
    };
};
